import React from 'react';

// Hand-drawn line glyphs (24x24, stroke = currentColor). Used by the travel
// maps, travel cards, and the traveler-mode backdrop. All original artwork.
const PATHS = {
  bicycle: (
    <>
      <circle cx="5.6" cy="17" r="3.4" />
      <circle cx="18.4" cy="17" r="3.4" />
      <path d="M5.6 17 L9.8 9.8 H14.6 L18.4 17 M9.8 9.8 L12.6 17 H5.6 M13.6 9.8 L12.6 7.4 H15.4 M8.2 7.4 h3" />
    </>
  ),
  motorbike: (
    <>
      <circle cx="5.4" cy="17.2" r="3" />
      <circle cx="18.6" cy="17.2" r="3" />
      <path d="M5.4 17.2 C7.4 13.6 10 13.2 12.2 14.4 L15 10 H17.6 M15 10 C15.8 12.8 16.8 14.4 18.6 17.2 M15 10 L13.4 8 M12.4 8 h3.4 M8.4 14 h4" />
    </>
  ),
  cub: (
    <>
      <circle cx="5.8" cy="17.4" r="2.9" />
      <circle cx="18.2" cy="17.4" r="2.9" />
      <path d="M5.8 17.4 L8.8 11.6 H12 C12.8 14.4 14.8 16.2 18.2 17.4 M8.8 11.6 C8 9.8 7.6 9 6.6 8.2 M5.4 8.2 H8.6 M12 11.6 L14.2 13.4 M16.4 12 C17 13.6 17.6 15 18.2 17.4" />
    </>
  ),
  tuktuk: (
    <>
      <circle cx="7" cy="17.6" r="2.6" />
      <circle cx="17" cy="17.6" r="2.6" />
      <path d="M4.6 8.4 Q4.6 6.4 6.6 6.4 H14.2 Q17 6.4 18.2 9 L19.6 12.4 V15 H19.4 M14.4 17.6 H9.6 M4.6 8.4 V15 M4.6 8.4 H14.6 M9.8 6.4 V12.4 H19.6 M9.8 12.4 H4.6" />
    </>
  ),
  thumb: (
    <>
      <path d="M4.6 11.4 H7.4 V19.4 H4.6 Z M7.4 18.2 Q8.8 19.4 10.4 19.4 H15.2 Q16.8 19.4 17.2 17.8 L18.8 11.8 Q19.2 10 17.4 10 H13.2 L14.2 6.6 Q14.6 4.6 12.8 4.2 Q11.8 4 11.4 5 L9.4 9.6 Q8.8 10.8 7.4 11.4" />
    </>
  ),
  bus: (
    <>
      <path d="M5 5.4 H19 Q20.4 5.4 20.4 6.8 V15 Q20.4 16.4 19 16.4 H5 Q3.6 16.4 3.6 15 V6.8 Q3.6 5.4 5 5.4 Z M3.6 11.6 H20.4 M8.4 5.4 V11.6 M15.6 5.4 V11.6 M6.2 14 H7.4 M16.6 14 H17.8" />
      <circle cx="7.2" cy="17.6" r="1.9" />
      <circle cx="16.8" cy="17.6" r="1.9" />
    </>
  ),
  train: (
    <>
      <path d="M6 4.8 H18 Q19.6 4.8 19.6 6.4 V14.2 Q19.6 15.8 18 15.8 H6 Q4.4 15.8 4.4 14.2 V6.4 Q4.4 4.8 6 4.8 Z M4.4 9.8 H19.6 M8.4 4.8 V9.8 M15.6 4.8 V9.8" />
      <circle cx="8" cy="13" r="1" />
      <circle cx="16" cy="13" r="1" />
      <path d="M7 15.8 L5 19.2 M17 15.8 L19 19.2 M8.6 17.6 H15.4" />
    </>
  ),
  backpack: (
    <>
      <path d="M7.2 8.6 Q7.2 6.2 9 5.6 Q9.4 3.6 12 3.6 Q14.6 3.6 15 5.6 Q16.8 6.2 16.8 8.6 V17.6 Q16.8 19.4 15 19.4 H9 Q7.2 19.4 7.2 17.6 Z M9.6 12 H14.4 V15.6 H9.6 Z M9.6 8.4 Q12 7.2 14.4 8.4 M4.8 10 Q4.4 14 5.6 16.4 M19.2 10 Q19.6 14 18.4 16.4" />
    </>
  ),
  campervan: (
    <>
      <circle cx="7.4" cy="16.8" r="2.2" />
      <circle cx="16.6" cy="16.8" r="2.2" />
      <path d="M5.2 16.8 H4.2 V9 Q4.2 7.6 5.6 7.6 H13 L16.2 10.2 H18.6 Q19.8 10.2 19.8 11.4 V16.8 H18.8 M9.6 16.8 H14.4 M6.2 9.6 H9 V12 H6.2 Z M11 9.6 H13.4 V12 H11 Z M6.6 7.6 V6 H11" />
    </>
  ),
  ship: (
    <>
      <path d="M4 15 L6 18 Q12 20 18 18 L20 15 Z M12 15 V5.2 M12 6 L17 12.4 H12 M7 15 V12 H17" />
    </>
  ),
  mountain: (
    <>
      <path d="M3.6 18.6 L9.6 7.2 L12.6 12.4 L14.8 8.6 L20.4 18.6 Z M8.2 10.4 L9.6 11.8 L11 10.4" />
    </>
  ),
  tent: (
    <>
      <path d="M12 5.4 L4 18.6 H20 Z M12 5.4 L12 8 M12 10 Q10.4 14.6 8.6 18.6 M12 10 Q13.6 14.6 15.4 18.6" />
    </>
  ),
  pagoda: (
    <>
      <path d="M12 3.2 V5 M7.6 7.4 Q12 5 16.4 7.4 M6.4 7.4 H17.6 M8.6 7.4 V10 M15.4 7.4 V10 M6.8 12.2 Q12 9.6 17.2 12.2 M5.6 12.2 H18.4 M8 12.2 V15 M16 12.2 V15 M6 17.2 Q12 14.4 18 17.2 M4.8 17.2 H19.2 M10 17.2 V20.4 M14 17.2 V20.4 M8 20.4 H16" />
    </>
  ),
  deer: (
    <>
      <path d="M9.2 20 V16.4 M12.8 20 V16.6 M16.6 20 V16.2 M6.8 20 V16.6 Q5.6 15.2 6 13.2 Q6.4 11.4 8.6 11.2 L14.6 11 Q16.4 11 17 12.6 L17.6 14.4 Q18 15.6 16.6 16.2 M8.6 11.2 Q7.6 9.6 8.2 8 L9.4 5.6 M9.4 8.4 Q10.4 8 10.8 6.8 M9.4 5.6 Q8.6 4.6 8.8 3.6 M9.4 5.6 Q10.4 4.8 10.6 3.8 M8.2 8 Q7 7.6 6.4 6.6" />
      <circle cx="10.6" cy="9.6" r="0.5" fill="currentColor" stroke="none" />
    </>
  ),
  compass: (
    <>
      <circle cx="12" cy="12" r="8.2" />
      <path d="M15.4 8.6 L13.2 13.2 L8.6 15.4 L10.8 10.8 Z" fill="currentColor" stroke="none" />
      <path d="M12 2.4 V4 M12 20 V21.6 M2.4 12 H4 M20 12 H21.6" />
    </>
  ),
};

export const BACKDROP_GLYPHS = [
  'deer', 'pagoda', 'mountain', 'tent', 'bicycle', 'tuktuk', 'cub', 'ship', 'backpack', 'compass',
];

function VehicleIcon({ type, className = '', strokeWidth = 1.5, ...rest }) {
  const paths = PATHS[type] || PATHS.backpack;

  return (
    <svg
      viewBox="0 0 24 24"
      className={className}
      aria-hidden="true"
      focusable="false"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...rest}
    >
      {paths}
    </svg>
  );
}

export default VehicleIcon;
